import script from "./GmxToast.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxToast.vue?vue&type=script&setup=true&lang=js"

import "./GmxToast.vue?vue&type=style&index=0&id=274b05a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274b05a0"]])

export default __exports__